import { render, staticRenderFns } from "./DistributionTableComponent.vue?vue&type=template&id=fe9b6b02&scoped=true"
import script from "./DistributionTableComponent.vue?vue&type=script&lang=js"
export * from "./DistributionTableComponent.vue?vue&type=script&lang=js"
import style0 from "./DistributionTableComponent.vue?vue&type=style&index=0&id=fe9b6b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9b6b02",
  null
  
)

export default component.exports